module.exports = __webpack_public_path__ + "img/Rylan James.b1dce60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/testimonial/Rylan James.jpg
// module id = 1144
// module chunks = 1